import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, getPpvRateWithCountsTooltipFormatter, mapIdsToLabels } from './chartUtils';

const OrganizationChatterPpvRateByTimeChart = ({ data, chatterLabelMap, dateRange, pending }) => {
  const { categories, series, tooltipFormatter } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.chatterId], chatterLabelMap)[0],
        data: item.ppvRate || [],
        offerCount: item.offerCount || [],
        purchaseCount: item.purchaseCount || [],
      })),
      tooltipFormatter: getPpvRateWithCountsTooltipFormatter(),
    }),
    [data, chatterLabelMap, dateRange],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Conversion Rate Over Time"
      subtitle="Conversion rate trend for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more chatters to load conversion rate over time."
      valueType="percent"
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationChatterPpvRateByTimeChart;
